export enum AddressType {
    Primary = 'PRIMARY',
    Email = 'E MAIL'
}
